// extracted by mini-css-extract-plugin
export default {"wrapper":"_42aa64a4","links":"_a5e5b644","link":"_c7efebf7","specify":"_47956564"};